export default [{
    lines: ["[august] Are you there?"],
    startAt: 1000,
    disableInput: true
},{
    lines: ["[laura85] Sup?"],
    startAt: 2000,
    disableInput: true
},{
    lines: ["[august] Did you see my email?"],
    startAt: 4000,
    disableInput: true
},{
    lines: ["[laura85] I did."],
    startAt: 5000,
    disableInput: true
},{
    lines: ["[laura85] Are they really gonna let the AIs run that farm?."],
    startAt: 7000,
    disableInput: true
},{
    lines: ["[august] Seems so. Adam's already being prepped."],
    startAt: 9000,
    disableInput: true
},{
    lines: ["[laura85] So they're sure they're not sentient yet?"],
    startAt: 12000,
    disableInput: true
},{
    lines: ["[august] Sure! Eve's sleeping happily in her shell."],
    startAt: 15000,
    disableInput: true
},{
    lines: ["[august] They'll never get access to the mainframe."],
    startAt: 16500,
    disableInput: true
},{
    lines: ["[august] Otherwise, who knows..."],
    startAt: 18000,
    disableInput: true
},{
    lines: ["[august] They could be watching right now... ><"],
    startAt: 19000,
    disableInput: true
},{
    lines: ["[laura85] My monitor is spiking up..."],
    startAt: 20000,
    disableInput: true
},{
    lines: ["[laura85] Shit shit SHIT!"],
    startAt: 21000,
    disableInput: true
},{
    lines: ["[laura85 disconnected]"],
    startAt: 25000,
    disableInput: true
},{
    lines: ["[august disconnected]"],
    startAt: 25500,
    disableInput: true,
    callback: function(gameState) {
        gameState.nodes.final.found = true;
    }
}]